import { Injectable } from '@nestjs/common';
import {CertificatesDTO} from './certificates.dto';
import {Certificates} from '../certificates.entity';

@Injectable()
export class CertificatesAdapter {
  
  public convertDtoToEntity(certificatesDTO: CertificatesDTO,  isUpdate: boolean = false ): Certificates {
    console.log(certificatesDTO);
    const certificates = new Certificates();
    certificates.certificateId=certificatesDTO.certificateId;
    certificates.certificateName=certificatesDTO.certificateName;
    certificates.remarks=certificatesDTO.remarks;
    // company.isActive = statesDto.isActive == undefined ? true : statesDto.isActive;
    certificates.isActive=certificatesDTO.isActive==undefined?true:certificatesDTO.isActive;
    if (isUpdate) {
        certificates.updatedUser = certificatesDTO.updatedUser;
    } else {
        certificates.isActive = true;
        certificates.createdUser = certificatesDTO.createdUser;
    }
   return certificates;
  }
  public convertEntityToDto(certificatesObject: Certificates): CertificatesDTO {
    const certificatesDto= new CertificatesDTO;
    certificatesDto.certificateId=certificatesObject.certificateId;
    certificatesDto.certificateName=certificatesObject.certificateName;
    certificatesDto.remarks=certificatesObject.remarks;
    certificatesDto.isActive = certificatesObject.isActive;
    certificatesDto.createdAt = certificatesObject.createdAt;
    certificatesDto.updatedAt = certificatesObject.updatedAt;
    certificatesDto.createdUser = certificatesObject.createdUser;
    certificatesDto.updatedUser = certificatesObject.updatedUser;
    certificatesDto.versionFlag = certificatesObject.versionFlag;
    return certificatesDto;
  }
}
